import { render, staticRenderFns } from "./TemplateUsages.vue?vue&type=template&id=eb4d79be&"
import script from "./TemplateUsages.vue?vue&type=script&lang=js&"
export * from "./TemplateUsages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports